import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, Menu, Video, X } from "lucide-react";
import { isLoggedin } from "../../lib/isLoggedin";

const NAV = [
  {
    label: "Home",
    to: "/",
    icon: Home,
  },
  {
    label: "VC Links",
    to: "/vc-links",
    icon: Video,
  },
  // {
  //   label: "Live Streaming",
  //   to: "/streaming",
  //   icon: Radio,
  // },
  // {
  //   label: "Recording",
  //   to: "/recordings",
  //   icon: Briefcase,
  // },
];

export default function PublicHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const loggedIn = isLoggedin();

  const accountLink = loggedIn ? "/dashboard" : "/";
  const accountLabel = loggedIn ? "Dashboard" : "Sign in";

  return (
    <header className="sticky top-0 z-50 border-b border-[var(--border)] bg-[var(--header-bg)] backdrop-blur-xl">
      <div className="mx-auto flex h-[76px] w-full max-w-[1440px] items-center justify-between px-5 sm:px-8 lg:px-12">
        <Link
          to="/"
          className="flex min-w-0 items-center gap-3 no-underline"
          aria-label="NyayNet home"
        >
          <span className="flex h-16 w-16 items-center justify-center rounded-[20px] bg-white/70 p-1.5 shadow-lg shadow-violet-500/15 ring-1 ring-white/80">
            <img
              src="/logo.png"
              alt="NyayNet"
              className="h-full w-full object-contain"
            />
          </span>
        </Link>

        <div className="hidden items-center gap-6 md:flex">
          <nav className="flex items-center gap-7">
            {NAV.map((item) => {
              const Icon = item.icon;
              const active = pathname === item.to;

              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`flex items-center gap-2 text-[17px] font-semibold no-underline transition ${
                    active
                      ? "text-[#5b45f5]"
                      : "text-slate-600 hover:text-slate-950"
                  }`}
                >
                  <Icon size={18} strokeWidth={2} />
                  {item.label}
                </Link>
              );
            })}
          </nav>

          {/* <Link
            to={accountLink}
            className="rounded-xl border border-slate-200 bg-white px-6 py-3 text-[16px] font-semibold text-slate-700 no-underline shadow-sm transition hover:border-[#5b45f5] hover:text-[#5b45f5]"
          >
            {accountLabel}
          </Link> */}

          <button
            type="button"
            onClick={() => navigate("/join-session")}
            className="inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-[#4f46e5] to-[#7c3aed] px-6 py-3 text-[16px] font-bold text-white shadow-lg shadow-violet-500/20 transition hover:translate-y-[-1px]"
          >
            <Video size={18} />
            Join Session
          </button>
        </div>

        <button
          type="button"
          className="flex h-11 w-11 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-700 shadow-sm md:hidden"
          onClick={() => setMenuOpen((open) => !open)}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
        >
          {menuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <div
        className={`overflow-hidden border-slate-200 bg-white transition-[max-height] duration-300 md:hidden ${
          menuOpen ? "max-h-[360px] border-t" : "max-h-0"
        }`}
      >
        <div className="space-y-2 px-5 py-4">
          {NAV.map((item) => {
            const Icon = item.icon;

            return (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className="flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-semibold text-slate-700 no-underline hover:bg-slate-50"
              >
                <Icon size={18} />
                {item.label}
              </Link>
            );
          })}

          <Link
            to={accountLink}
            onClick={() => setMenuOpen(false)}
            className="block rounded-xl border border-slate-200 px-4 py-3 text-center text-sm font-semibold text-slate-700 no-underline"
          >
            {accountLabel}
          </Link>

          <button
            type="button"
            onClick={() => {
              setMenuOpen(false);
              navigate("/join-session");
            }}
            className="flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#4f46e5] to-[#7c3aed] px-4 py-3 text-sm font-bold text-white"
          >
            <Video size={18} />
            Join Session
          </button>
        </div>
      </div>
    </header>
  );
}
